// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bill-edit-charge-dialog[data-v-a874a2e6] .el-input-number .el-input input {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
